(function ($) {

  // The general 'default' background color for blocks is white
  var defaultBackgroundColor = '#ffffff';

  // Automatically return rgb/rgba colors as hex values
  $.cssHooks.backgroundColor = {
    get: function (elem) {

      // Converts colors like rgb(0,0,0) to #000000 and rgba(0,0,0,0) to #00000000
      function colorToHex(original) {
        var parts = original.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i);

        // Deal with the component parts
        if (parts) {
          var r = (parts[1] | 1 << 8).toString(16).slice(1);
          var g = (parts[2] | 1 << 8).toString(16).slice(1);
          var b = (parts[3] | 1 << 8).toString(16).slice(1);

          // The alpha value is between 1.0 & 0.0 and needs conversion
          var a = '';
          var alpha = (parts[4] || '').trim();
          if (alpha !== '') {
            a = ((alpha * 255) | 1 << 8).toString(16).slice(1);
          }

          // If alpha is '00' (transparent) or all values 'ff' it is
          // equivalent to basic white in our case (for comparison).
          if (a === '00' || (r === 'ff' && g === 'ff' && b === 'ff' && a === 'ff')) {
            return defaultBackgroundColor;
          }
          else {
            return ('#' + r + g + b + a).toLowerCase();
          }
        }
        else {
          return original.toLowerCase(); // Already Hex!
        }
      }

      // Get the element's background color
      var bg = window.getComputedStyle(elem, null).getPropertyValue('background-color');

      // Returned background color may not be a standard 6 character hex color value
      if (bg.search('transparent') !== -1) {
        // If 'transparent' (IE) it's equivalent to white in our case (for comparison).
        bg = defaultBackgroundColor;
      }
      else {
        // Validate and convert if not already a hex color value
        bg = colorToHex(bg);
      }

      return bg;
    }
  };

  // Block background color comparison
  function matchingBGColor($block1, $block2) {
    // Prevent comparison against non-existent prev/next children resulting in 'undefined' value
    if ($block2.length === 0) {
      return false;
    }
    // If either block has a background image, that means they are either image based or have a gradient.
    // In that case, we need to compare the background-image instead of background-color.
    if ($block1.children('.row').first().css('background-image') !== 'none' || $block2.children('.row').first().css('background-image') !== 'none') {
      return $block1.children('.row').first().css('background-image') === $block2.children('.row').first().css('background-image');
    }
    return $block1.children('.row').first().css('backgroundColor') === $block2.children('.row').first().css('backgroundColor');
  }

  // Unlike other background-color blocks, blocks with white backgrounds do not
  // have any 'whitespace' (background color padding) that can be collapsed. We
  // also need to ignore blocks that have a background image specified as that
  // can introduce unexpected block spacing behaviour too.
  function collapseWhitespace($block1, $block2) {
    if (!$block1.hasClass('bg-image') && !$block2.hasClass('bg-image') &&
      $block1.children('.row').first().css('backgroundColor') !== defaultBackgroundColor) {
      $block1.addClass('collapse-whitespace');
    }
  }

  $(document).ready(function () {

    //
    // Block presentation logic (only full-width layouts).
    //

    // 'Hero' is generic for 'top' blocks like Hero CTA.
    // Check 'Hero' for 'full-bleed' & enable other 'full-bleed' blocks on page.
    if ($('.block.top').length && $('.block.top').hasClass('full-bleed')) {
      $('.block.full-bleed-ready').toggleClass('full-bleed-ready full-bleed');
      // Also enable 'full-bleed' for any appropriate 50/50 Banner blocks.
      $('#content > .layout.col2-50-50-fw').each(function () {
        if ($('.block.banner.full-bleed', $(this)).length === 2) {
          $(this).addClass('full-bleed');
        }
      });
    }

    // Flag if full-width block or multi-column layout after hero was handled.
    var postHeroProcessed = false;

    // Get a list of all non-empty layouts.
    // Empty layouts are still output and really mess up the below logic.
    var layouts = [];
    $('#content > .layout').each(function () {
      if ($(this).find('.block').length > 0) {
        layouts.push($(this));
      }
    });

    // Loop through our layouts and process desired block-to-block interactions
    for (var layout = 0; layout < layouts.length; layout++) {
      var lastLayout = layouts.length - 1;
      var $prevLayout = $(layouts[layout - 1]);
      var $thisLayout = $(layouts[layout]);
      var $nextLayout = $(layouts[layout + 1]);

      // Check if full-width single column layout
      if ($thisLayout.hasClass('col1')) {

        // Get list of all blocks in single-column layouts
        var blocks = $('.layout-col > .block', $thisLayout);
        for (var block = 0; block < blocks.length; block++) {
          var lastBlock = blocks.length - 1;
          var $prevBlock = $(blocks[block - 1]);
          var $thisBlock = $(blocks[block]);
          var $nextBlock = $(blocks[block + 1]);

          // Process top of the page - with or without a 'Hero' block
          var $heroBlock = $('.block.hero-cta.top');
          if (((layout === 0) && (block === 1) && (blocks.length > 1)) ||
              ((layout === 1) && (block === 0) && (!postHeroProcessed))) {
            // Need to see if there is even a 'Hero' placed on the page
            if ($heroBlock.length) {
              // Only image-based Hero should collapse bottom margin
              if ($heroBlock.hasClass('full-width') && $heroBlock.hasClass('allow-no-bottom-margin') && $thisBlock.hasClass('full-width')) {
                $thisBlock.toggleClass('allow-no-bottom-margin no-bottom-margin');
              }
            }
            // No 'Hero' at all, so need to reset any manually set rounding if applicable
            else {
              if ($thisBlock.hasClass('rounded-top')) {
                $thisBlock.removeClass('rounded-top');
              }
              else if ($thisBlock.hasClass('rounded-both')) {
                $thisBlock.removeClass('rounded-both').addClass('rounded-bottom');
              }
            }
            postHeroProcessed = true;
          }

          // Handle first block in each single-column layout on page...
          if (block === 0) {
            // Previous layout is also single-column, so dig down to first block (further processed later)
            if ($prevLayout.hasClass('col1')) {
              $prevBlock = $('.block:last-child', layouts[layout - 1]);
            }
            // Previous layout is not single-column, so add applicable class to layout if current block rounded
            else {
              if ($thisBlock.hasClass('rounded-both') || $thisBlock.hasClass('rounded-top')) {
                $prevLayout.addClass('rounded-block-below');
              }
            }
          }

          // Handle last block in each single-column layout on page...
          if (block === lastBlock) {
            // Last block in all layouts (except the last layout)
            if (layout < lastLayout) {
              // Next layout is also single-column, so dig down to first block (further processed later)
              if ($nextLayout.hasClass('col1')) {
                $nextBlock = $('.block:first-child', layouts[layout + 1]);
              }
              // Next layout is not single-column, so add applicable classes to layout if current block rounded etc.
              else {
                if ($thisBlock.hasClass('rounded-both') || $thisBlock.hasClass('rounded-bottom')) {
                  $nextLayout.addClass('rounded-block-above');
                }
              }
            }
            // Last block in last layout (special treatment)
            else if (layout === lastLayout) {
              // Last block is rounded - remove 'gingerbread'
              if ($thisBlock.hasClass('rounded-both')) {
                $thisBlock.removeClass('rounded-both').addClass('rounded-top');
              }
              else if ($thisBlock.hasClass('rounded-bottom')) {
                $thisBlock.removeClass('rounded-bottom');
              }

              // Last block is full-width and does not have a white background - remove natural block whitespace
              if ($thisBlock.hasClass('full-width') &&
                ($thisBlock.children('.row').first().is("[class*='grad']") ||
                $thisBlock.children('.row').first().css('backgroundColor') !== defaultBackgroundColor)) {
                $thisBlock.addClass('no-bottom-margin');
              }
            }
          }

          // Handle full-width block next to another full-width block
          // Might be able to handle this via CSS rather than JS (via 'full-width' class)...
          if ($thisBlock.hasClass('full-width') && $thisBlock.hasClass('allow-no-bottom-margin') && $nextBlock.hasClass('full-width')) {
            $thisBlock.toggleClass('allow-no-bottom-margin no-bottom-margin');
          }

          // Handle cases where rounded blocks are placed next to blocks
          // with same background color that introduces extra spacing...
          var prevBGColorMatch = matchingBGColor($thisBlock, $prevBlock);
          var nextBGColorMatch = matchingBGColor($thisBlock, $nextBlock);

          // Collapse space between if butted up against each other.
          if ($thisBlock.hasClass('no-bottom-margin') && nextBGColorMatch) {
            collapseWhitespace($thisBlock, $nextBlock);
          }

          if ($thisBlock.hasClass('rounded-both')) {
            if (prevBGColorMatch) {
              $thisBlock.removeClass('rounded-both').addClass('rounded-bottom');
            }
            else if (nextBGColorMatch) {
              $thisBlock.removeClass('rounded-both').addClass('rounded-top');
              collapseWhitespace($thisBlock, $nextBlock);
            }
          }

          if ($thisBlock.hasClass('rounded-top') && prevBGColorMatch) {
            $thisBlock.removeClass('rounded-top');
          }

          if ($thisBlock.hasClass('rounded-bottom') && nextBGColorMatch) {
            $thisBlock.removeClass('rounded-bottom');
            collapseWhitespace($thisBlock, $nextBlock);
          }

          // If a block is rounded on the bottom, but the next block is rounded
          // on the top, the block below takes precedence so adjust block above.
          if ($nextBlock.hasClass('rounded-both') || $nextBlock.hasClass('rounded-top')) {
            if ($thisBlock.hasClass('rounded-both')) {
              $thisBlock.removeClass('rounded-both').addClass('rounded-top');
            }
            else if ($thisBlock.hasClass('rounded-bottom')) {
              $thisBlock.removeClass('rounded-bottom');
            }
          }

          // Handle rounded block interactions (manually set in block by author)
          // by adding additional classes to adjust the internal block padding
          if ($thisBlock.hasClass('rounded-both')) {
            $prevBlock.addClass('rounded-block-below');
            $nextBlock.addClass('rounded-block-above');
          }
          else if ($thisBlock.hasClass('rounded-top')) {
            $prevBlock.addClass('rounded-block-below');
          }
          else if ($thisBlock.hasClass('rounded-bottom')) {
            $nextBlock.addClass('rounded-block-above');
          }
        }
      }

      // The 50/50 full-width layout (Twin Banner) requires special attention

      // Remove bottom margin if 50/50 is last layout on page
      if ($thisLayout.hasClass('col2-50-50-fw') && (layout === lastLayout)) {
        $thisLayout.addClass('no-bottom-margin');
      }

      // Check if current layout is full-width 50/50
      if ($thisLayout.hasClass('col2-50-50-fw')) {
        // If the first block of the next layout has a background color or image,
        // remove the bottom margin of current 50/50 layout if both child Banner
        // blocks have their 'Remove bottom margin' checkboxes checked.
        var $nextLayoutFirstBlock = $('.block:first-child', $nextLayout);
        if ($('.block.banner.allow-no-bottom-margin', $thisLayout).length >= 2 &&
          (($nextLayoutFirstBlock.children('.row').first().css('background-image') !== 'none') ||
          ($nextLayoutFirstBlock.children('.row').first().css('background-color') !== defaultBackgroundColor))) {
          $thisLayout.addClass('no-bottom-margin');
        }
      }

      // Check if next layout is full-width 50/50
      if ($nextLayout.hasClass('col2-50-50-fw')) {
        // If the last block of the current layout has a background color or image,
        // and has its 'Remove bottom margin' checkbox checked, remove the bottom
        // margin of the last block.
        var $thisLayoutLastBlock = $('.block:last-child', $thisLayout);
        if ($thisLayoutLastBlock.hasClass('allow-no-bottom-margin') &&
          (($thisLayoutLastBlock.children('.row').first().css('background-image') !== 'none') ||
          ($thisLayoutLastBlock.children('.row').first().css('background-color') !== defaultBackgroundColor))) {
          $thisLayoutLastBlock.toggleClass('allow-no-bottom-margin no-bottom-margin');
        }
      }
    }
  });

})(jQuery);
